export default __webpack_public_path__ + "static/media/certificatearabic.35645eff.png";